module.exports = __webpack_public_path__ + "static/media/collection-bird-getting.1d2298c3.mp3";